const setListOfRushOptions = (list) => {
    return {
        type: 'SET_LIST_RUSH_OPTIONS',
        payload: list
    };
};

//eslint-disable-next-line
export default {
    setListOfRushOptions
};
